import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { SettingsDataService, SettingsColumnsService } from '../../../services';
import { Setting, SettingsResult } from '../../../interfaces';

@Component({
  selector: 'app-setting-form',
  templateUrl: './setting-form.component.html',
  styleUrls: ['./setting-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class SettingFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public setting: Setting = {};
  public settingForm: FormGroup = new FormGroup({});
  public settings: Setting[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private settingsDataService: SettingsDataService,
    public settingsColumnsService: SettingsColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'SettingFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Setting - Edit');
        this.getSetting(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.setting !== 'undefined') {
      this.setting = this.dynamicDialogConfig.data.setting;
    }
    if (typeof this.setting.id === 'undefined' || this.setting.id === null) {
      this.setting.id = null;
    }
    this.getSettings();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'SettingFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'SettingFormComponent');
  }

  getSetting(id: number): void {
    this.isLoading = true;
    this.settingsDataService.getSetting(id).subscribe((response: Setting|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.setting = response;
        this.prepareFrom();
      }
    });
  }

  getSettings(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.settings !== 'undefined' && this.dynamicDialogConfig.data.settings.length > 0) {
      this.settings = this.dynamicDialogConfig.data.settings;
      return;
    }
    this.settingsDataService.getSettings(this.parameters).subscribe((response: SettingsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.settings = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.settingForm = new FormGroup({
      id: new FormControl(this.setting.id, []),
      name: new FormControl(this.setting.name, [Validators.required, ]),
      type: new FormControl(this.setting.type, []),
      settingValue: new FormControl(this.setting.settingValue, []),
      defaultValue: new FormControl(this.setting.defaultValue, []),
    });
  }

  list() {
    this.router.navigate(['/settings']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.settingForm.controls).forEach((field: any) => {
        const control = this.settingForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.settingForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.setting = this.settingForm.value;
    this.disableSubmit = true;
    console.log('setting', this.setting);
    if (typeof this.setting.id !== 'undefined' && this.setting.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.settingsDataService.updateSetting(this.setting).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('SETTINGUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('SETTINGNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.settingsDataService.addSetting(this.setting).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('SETTINGCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('SETTINGNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-setting-form',
  templateUrl: './setting-form.component.html',
  styleUrls: ['./setting-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogSettingFormComponent extends SettingFormComponent {
}

